import React from 'react';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  width?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ value, onChange, placeholder, width = "w-80" }) => {
  return (
    <div className={`relative ${width}`}>
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-10">
          <svg 
            aria-hidden="true" 
            className="w-5 h-5 text-gray-500 dark:text-gray-400" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
            />
          </svg>
        </div>
        <input 
          type="text"
          onChange={onChange} 
          className="w-full py-2 px-4 pl-10 rounded-lg border border-gray-500 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-100 text-sm transition-all duration-200 h-[42px] focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500 hover:border-blue-500 dark:hover:border-blue-500"
          placeholder={placeholder} 
          value={value}
        />
      </div>
    </div>
  );
};

export default SearchInput; 